export const LANDING_PAGE_BUILDER = "landing-page-builder";
export const FORMS = "forms";
